import * as React from "react";
import { ROUTE_ACTIVITIES, ROUTE_CONTACT, ROUTE_COVID_RULES, ROUTE_EVENTS, ROUTE_HOME, ROUTE_POSTER_CHAMPION_SHIP_2023, ROUTE_POSTER_CHAMPION_SHIP_2024, ROUTE_POSTER_CHAMPION_SHIP_2025 } from "./Routes";
import ActivitiesScreen from "../modules/activities/ActivitiesScreen";
import ClubScreen from "../modules/club/ClubScreen";
import ContactScreen from "../modules/contact/ContactScreen";
import CovidContent from "../modules/infoCovid/CovidContent";
import {
    BrowserRouter,
    Routes,
    Route,
} from 'react-router-dom';
import { EventsScreen } from "../modules/events/EventsScreen";
import { DownLoadPoster2023 } from "../modules/events/DownLoadPoster2023";
import { DownLoadPoster2024 } from "../modules/events/DownLoadPoster2024";
import { DownLoadPoster2025 } from "../modules/events/DownLoadPoster2025";

type Props = {};

export default class Routing extends React.Component<Props> {

    public render(): React.ReactNode {

        return (
            <BrowserRouter>
                <Routes>
                    <Route path={ROUTE_HOME} element={<ClubScreen />} />
                    
                    <Route path={ROUTE_EVENTS} element={<EventsScreen />} />
                    <Route path={ROUTE_POSTER_CHAMPION_SHIP_2023} element={<DownLoadPoster2023 />} />
                    <Route path={ROUTE_POSTER_CHAMPION_SHIP_2024} element={<DownLoadPoster2024 />} />
                    <Route path={ROUTE_POSTER_CHAMPION_SHIP_2025} element={<DownLoadPoster2025 />} />

                    <Route path={ROUTE_ACTIVITIES} element={<ActivitiesScreen />} />
                    
                    <Route path={ROUTE_CONTACT} element={<ContactScreen />} />
                    
                    <Route path={ROUTE_COVID_RULES} element={<CovidContent />} />
                </Routes>
            </BrowserRouter>
        )

    }
}